import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalsService } from 'app/services/globals.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { OmsService } from 'app/services/oms.service';
import { OrdersService } from 'app/services/orders.service';
import { UsersService } from 'app/services/users.service';
import { Subject, of } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { Location } from '@angular/common'

import { CustomerService } from '../../services/customer.service';
import { MatTableDataSource } from '@angular/material/table';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-order-upload',
	templateUrl: './order-upload.component.html',
	styleUrls: ['./order-upload.component.scss']
})
export class OrderUploadComponent implements OnInit {

	// @ViewChild('itemdetails') itemDetails: ElementRef;
	// @ViewChild('purchasedetails') purchasedetails: ElementRef;
	// @ViewChild('creditover') creditover: ElementRef;
	// @ViewChild('configproductele') configproductele: ElementRef;
	// @ViewChild('itemHistoryRef') itemHistoryRef: ElementRef;
	// @ViewChild('nonstock') nonstockref: ElementRef;
	// @ViewChild('uploadorder') uploadorderref: ElementRef;
	// @ViewChild('fileInput') fileInput: ElementRef;


	CHAT_ROOM = 'OrderBoard';
	orderResults: any = [];
	customer_data: any = [];
	filters: any = [];
	debtorno: any = '';
	branchcode: any = '';

	poHelp = false;
	uploadedHeaders: string[] = [];
	uploadedRawData: any[] = [];
	columnMappings: any = {};
	availableFieldTypes: string[] = ['stockid', 'qty_purchase', 'price', 'description', 'ignore'];
	requiredMappings: any = { 'stockid': false, 'qty_purchase': false, 'price': false };
	hasDuplicateMappings = false;
	hasRequiredMappings: any = false;
	fileSpecificHeaders: { [fileName: string]: string[] } = {};
	fileSpecificMappings: { [fileName: string]: { [header: string]: string } } = {};
	selectedFile = 'all';
	availableFiles: string[] = [];
	files: File[] = [];
	orderUploadColumns: string[] = ['stockid', 'description', 'quantity', 'price'];
	uploaddata: any = false;
	orderDataSource: any = false;
	orderReviewReady = false;
	/** Initial parse / server upload (dropzone step). */
	processing_recs = false;
	/** Re-validate after user edits column mapping. */
	mappingApplyProcessing = false;
	orderUploadSelectedTabIndex = 0;
	/** Max rows shown in the mapping preview table (all rows still used on Apply). */
	readonly orderUploadMappingPreviewMax = 50;
	upload_error: any = false;
	fieldMatch = true;
	today = new Date();
	lastsearch: any = '';
	//cart
	dspcost = true;
	showGuide = false;
	total_cart_qty = 0;
	cart_items: any = [];
	cart_totals: any = [];
	selectedindex = 0;
	activeLink: any = 'order_entry';

	//subscription to search
	inventorysearching: any = false;

	search_items: any = [];
	filtered_items: any = [];
	searching = false;

	taxgroups: any = [];
	salespeople: any = [];
	shipvia: any = [];
	terms: any = [];
	zones: any = [];
	locations: any = [];
	holdreasons: any = [];
	itemhistory: any = [];


	addingitems = false;
	customerinfo = true;
	//viewing item
	item_details: any = false;
	editing_order = false;
	order_details: any = [];
	purchase_items: any = [];
	user: any = [];

	showfilters = false;
	overcredit = false;
	allowed_credit = true;
	proceed = true;
	overcredit_override = '';
	selecteditem: any = false;
	config: any = [];
	/** Theme key for dropzone — matches `card-header-{{color}}-5` from app config. */
	color: string = 'blue';

	nonStockForm: UntypedFormGroup;
	brands: any = [];
	librarysearch = new UntypedFormControl('');
	librarySearchResults: any = [];
	librarySearchSelected: any = false;
	librarySearching: any = false;
	collapseMini: any = false;
	customerdatafortrans: any = false;

	resetTrans: Subject<boolean> = new Subject<boolean>();
	dupedSuppliedHeaders: any = false;
	suppliedHeaders: any = false;
	lookupType = false;
	mappingsFulfilled: any = { status: false, missing:[] };

	@Input() customerdata: any = null;
	@Output() uploaded = new EventEmitter<any>();


	constructor(private printService: PrintService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService) {

		this.config = this.globalsService.getApiConfig();
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe((r: any) => {
			if (r) {
				this.config = r;
			}
		});
	}

	/** Theme key for ngx-dropzone styling. */
	get dropzoneThemeColor(): string {
		const allowed = new Set(['blue', 'azure', 'purple', 'green', 'red']);
		const c = String(this.color || 'blue')
			.toLowerCase()
			.trim();
		return allowed.has(c) ? c : 'blue';
	}

	orderUploadFieldLabel(field: string): string {
		const labels: Record<string, string> = {
			stockid: 'Item # (stockid)',
			qty_purchase: 'Quantity',
			price: 'Unit price',
			description: 'Description',
			brand: 'Brand / MFG',
			ignore: '— Ignore column —',
		};
		return labels[field] || field;
	}

	ngOnInit(): void {

		this.globalSearchService.mesagesallowed.next(false);
		
		// Check if customer data is provided as input
		if (this.customerdata) {
			this.customer_data = this.customerdata;
			this.debtorno = this.customerdata.customer.debtorno;
			this.branchcode = this.customerdata.customer.branchcode;
			this.customer_data.dissallowinvoices = false;
			// Load additional data for the provided customer
			this.loadCustomerData();
		} else {
			// Fallback to route parameters if no customer data provided
			this.customer_data.dissallowinvoices = false;

			this.route.params
				.pipe(
					// Only proceed if the debtor number or branch code has changed
					filter(params => this.debtorno !== params['cid'] || this.branchcode !== params['branch']),
					tap(params => {
						// Update local variables
						this.debtorno = params['cid'];
						this.branchcode = params['branch'];
					}),
					// Use switchMap to flatten the inner subscription
					switchMap(params =>
						this.orderService.getCustomer(this.debtorno, this.branchcode).pipe(
							catchError(err => {
								//'Failed to load customer data:', err);
								return of(null); // Handle the error gracefully
							})
						)
					),
					filter(results => !!results), // Proceed only if customer data is successfully loaded
					tap(results => {
						this.customer_data = results;
					}),
					// Fetch additional details related to the debtor and branch
					switchMap(results =>
						this.customerService.getDebtorWithBranch(results.debtorno, results.branchcode).pipe(
							catchError(err => {
							//'Failed to load debtor details:', err);
								return of(null); // Handle the error gracefully
							})
						)
					)
				)
				.subscribe((customerDetails: any) => {
					if (customerDetails) {
						this.customerdatafortrans = customerDetails;
					} else {
					//'No customer details were found.');
					}
				});
		}
	}

	loadCustomerData() {
		// Load additional customer data when customerdata is provided as input
		this.customerService.getDebtorWithBranch(this.debtorno, this.branchcode)
			.pipe(
				catchError(err => {
					//'Failed to load debtor details:', err);
					return of(null);
				})
			)
			.subscribe((customerDetails: any) => {
				if (customerDetails) {
					this.customerdatafortrans = customerDetails;
				} else {
					//'No customer details were found.');
				}
			});
	}


	private readonly orderUploadAllowedExtensions = ['.csv', '.xlsx', '.xls'];

	/** Synonyms for scoring header → target field (same idea as inventory upload). */
	private readonly orderUploadFieldSynonyms: Record<string, string[]> = {
		stockid: ['stockid', 'sku', 'itemnumber', 'itemnum', 'item', 'partnumber', 'partnum', 'part', 'productcode', 'stylenum', 'style', 'product'],
		qty_purchase: ['qty', 'quantity', 'qtypurchase', 'orderqty', 'qtyordered', 'purchaseqty', 'orderquantity'],
		price: ['price', 'unitprice', 'sellprice', 'listprice', 'netprice', 'unitcost', 'cost'],
		description: ['description', 'desc', 'longdesc', 'title', 'name'],
		brand: ['brand', 'mfg', 'make', 'manufacturer', 'mfgname'],
	};

	private normalizeOrderHeaderForMatch(s: string): string {
		return String(s || '')
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '');
	}

	/** Score how well `header` matches order field `field` (0 = no match). */
	private scoreOrderFieldHeader(field: string, header: string): number {
		if (field === 'brand' && !this.lookupType) {
			return 0;
		}
		const hn = this.normalizeOrderHeaderForMatch(header);
		if (!hn) {
			return 0;
		}
		const fn = this.normalizeOrderHeaderForMatch(field);
		if (hn === fn) {
			return 100;
		}
		let best = 0;
		const syns = this.orderUploadFieldSynonyms[field];
		if (syns) {
			for (const syn of syns) {
				const sn = this.normalizeOrderHeaderForMatch(syn);
				if (!sn) {
					continue;
				}
				if (hn === sn) {
					best = Math.max(best, 92);
				} else if (hn.includes(sn) && sn.length >= 4) {
					best = Math.max(best, 72);
				} else if (hn.includes(sn) && sn.length >= 3) {
					best = Math.max(best, 52);
				} else if (sn.includes(hn) && hn.length >= 4) {
					best = Math.max(best, 58);
				}
			}
		}
		return best;
	}

	/**
	 * Greedy match: each file column → at most one target; each target → at most one column (matches inventory upload).
	 */
	private buildGreedyOrderColumnMappings(headers: string[]): { [header: string]: string } {
		const result: { [header: string]: string } = {};
		for (const h of headers) {
			result[h] = 'ignore';
		}
		const targetFields = this.availableFieldTypes.filter((f) => f !== 'ignore');
		const fieldIndex = (f: string) => targetFields.indexOf(f);
		const pairs: { field: string; header: string; score: number }[] = [];
		for (const header of headers) {
			for (const field of targetFields) {
				const sc = this.scoreOrderFieldHeader(field, header);
				if (sc >= 40) {
					pairs.push({ field, header, score: sc });
				}
			}
		}
		pairs.sort((a, b) => {
			if (b.score !== a.score) {
				return b.score - a.score;
			}
			return fieldIndex(a.field) - fieldIndex(b.field);
		});
		const usedHeaders = new Set<string>();
		const usedFields = new Set<string>();
		for (const p of pairs) {
			if (usedHeaders.has(p.header) || usedFields.has(p.field)) {
				continue;
			}
			result[p.header] = p.field;
			usedHeaders.add(p.header);
			usedFields.add(p.field);
		}
		return result;
	}

	clearAllFiles() {
		this.files = [];
		this.upload_error = false;
	}


	initializeColumnMappings() {
		// this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.columnMappings = {};
		this.availableFiles.forEach(fileName => {
			if (!this.fileSpecificMappings[fileName]) {
				if (!this.fileSpecificHeaders[fileName] || this.fileSpecificHeaders[fileName].length === 0) {
					const fileRows = this.uploadedRawData.filter(row => row._sourceFile === fileName);
					if (fileRows.length > 0) {
						const headerKeys = Object.keys(fileRows[0]).filter(key => key !== '_sourceFile');
						this.fileSpecificHeaders[fileName] = headerKeys;
					}
				}

				if (!this.fileSpecificHeaders[fileName]?.length) {
					return;
				}
				this.fileSpecificMappings[fileName] = this.buildGreedyOrderColumnMappings(this.fileSpecificHeaders[fileName]);
			}
		});

		this.uploadedHeaders = [];
		this.availableFiles.forEach(fileName => {
			if (this.fileSpecificHeaders[fileName]) {
				this.uploadedHeaders = [...new Set([...this.uploadedHeaders, ...this.fileSpecificHeaders[fileName]])];
			}
		});

		this.uploadedHeaders.forEach(header => {
			let mappingType = '';
			let consistent = true;

			for (const fileName of this.availableFiles) {
				if (this.fileSpecificHeaders[fileName] && this.fileSpecificHeaders[fileName].includes(header)) {
					const fileMapping = this.fileSpecificMappings[fileName][header];
					if (mappingType === '') {
						mappingType = fileMapping;
					} else if (mappingType !== fileMapping) {
						consistent = false;
						break;
					}
				}
			}

			this.columnMappings[header] = consistent ? mappingType : 'ignore';
		});
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.syncMappingsFulfilledStatus();
	}



	exportBad(type){
		const filename = 'order_upload_unrecgonized' + (type == 'pdf' ? '.pdf' : '.xlsx');

		let html = '<table style="width: 100%"><thead><tr>';
			html += `<th style='text-align: left'>Item</th>`;
			html += `<th style='text-align: left'>Description</th>`;
			html += `<th style='text-align: right'>Price</th>`;
			html += `<th style='text-align: right'>Qty</th>`;
			html += `</tr></thead><tbody>`;
			(this.orderDataSource['bad'].data).forEach(row => {
				html += `<tr>`
				html += `<td style='text-align: left'>${row.stockid}</td>`
				html += `<td style='text-align: left'>${row.description}</td>`
				html += `<td style='text-align: right'>${row.price}</td>`
				html += `<td style='text-align: right'>${row.quantity}</td>`
				html += `</tr>`
			});
			html += `</tbody></table>`

		const encoded = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: filename,
			title: `Unrecognized order upload lines`,
		};

		if(type == 'pdf'){
			this.printService.pdf(data).subscribe({
				next: (result: any) => {this.globalSearchService.downloadPdf(result.content, data.filename)},
				error: () => {},
			});
		}else{
			this.printService.xls(data).subscribe({
				next: (result: any) => {this.globalSearchService.downloadXls(result.content, data.filename)},
				error: () => {},
			});
		}
	}

	syncMappingsFulfilledStatus(): void {
		this.checkForRequiredFields();
		const allMapped = Object.values(this.requiredMappings).every(Boolean);
		this.mappingsFulfilled = {
			status: allMapped,
			missing: Object.entries(this.requiredMappings).filter(([, v]) => !v).map(([k]) => k)
		};
	}

	get orderUploadMappingPreviewRows(): any[] {
		const cap = this.orderUploadMappingPreviewMax;
		let rows = this.uploadedRawData || [];
		if (this.selectedFile !== 'all') {
			rows = rows.filter(r => r._sourceFile === this.selectedFile);
		}
		return rows.slice(0, cap);
	}

	get orderUploadMappingPreviewTotal(): number {
		let rows = this.uploadedRawData || [];
		if (this.selectedFile !== 'all') {
			rows = rows.filter(r => r._sourceFile === this.selectedFile);
		}
		return rows.length;
	}

	private readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result as ArrayBuffer);
			reader.onerror = () => reject(new Error('read_failed'));
			reader.readAsArrayBuffer(file);
		});
	}

	private readFileAsTextUtf8(file: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(String(reader.result ?? ''));
			reader.onerror = () => reject(new Error('read_failed'));
			reader.readAsText(file, 'UTF-8');
		});
	}

	private orderRowsFromWorkbook(wb: XLSX.WorkBook): Record<string, string>[] {
		const sheetName = wb.SheetNames[0];
		if (!sheetName) {
			return [];
		}
		const ws = wb.Sheets[sheetName];
		const raw = XLSX.utils.sheet_to_json<Record<string, unknown>>(ws, { defval: '', raw: false });
		return raw.map((row) => {
			const o: Record<string, string> = {};
			for (const k of Object.keys(row)) {
				const v = row[k];
				o[k] = v === null || v === undefined ? '' : String(v);
			}
			return o;
		});
	}

	/**
	 * CSV: read as UTF-8 text (fixes BOM / MIME quirks). Excel: array buffer.
	 */
	private parseOrderSpreadsheetLocal(file: File): Promise<Record<string, string>[]> {
		const name = file.name.toLowerCase();
		if (name.endsWith('.csv')) {
			return this.readFileAsTextUtf8(file).then((text) => {
				try {
					const normalized = text.replace(/^\uFEFF/, '');
					const wb = XLSX.read(normalized, { type: 'string', cellDates: true, raw: false });
					return this.orderRowsFromWorkbook(wb);
				} catch {
					throw new Error('parse_failed');
				}
			});
		}
		return this.readFileAsArrayBuffer(file).then((buf) => {
			try {
				const wb = XLSX.read(buf, { type: 'array', cellDates: true, dense: false });
				return this.orderRowsFromWorkbook(wb);
			} catch {
				throw new Error('parse_failed');
			}
		});
	}

	updateColumnMapping(originalHeader: string, newMapping: string, fileName: string = null) {
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		if (fileName) {
			this.fileSpecificMappings[fileName][originalHeader] = newMapping;
		} else {
			this.columnMappings[originalHeader] = newMapping;

			if (this.selectedFile === 'all') {
				this.availableFiles.forEach(file => {
					if (this.fileSpecificHeaders[file].includes(originalHeader)) {
						this.fileSpecificMappings[file][originalHeader] = newMapping;
					}
				});
			}
		}


		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.syncMappingsFulfilledStatus();
	}

	checkForRequiredFields(){

		let headers;
		if(this.selectedFile !== 'all'){
			headers = this.fileSpecificMappings[this.selectedFile];
		}else{
			headers = this.columnMappings;
		}

		//reset req maps to false
		const req_maps = Object.keys(this.requiredMappings);
		Object.keys(this.requiredMappings).forEach((k) => {
			this.requiredMappings[k] = false;
		})

		//update req maps based on mapped column values
		Object.values(headers).forEach((mappedname: any) => {
			if(req_maps.includes(mappedname)){
				this.requiredMappings[mappedname] = true;
			}
		});

		//return if all are supplied or if any are false
		let value = true;
		Object.values(this.requiredMappings).forEach((mapped) => {
			if(!mapped){
				value = false;
			}
		})

		return value;
	}

	checkForDuplicateMappings(): boolean {
		const fileName = this.selectedFile;
		this.dupedSuppliedHeaders = {};
		this.suppliedHeaders = {};
		const foundMaps = [];
		// For single file view
		if (fileName !== 'all') {
			if (!this.fileSpecificMappings[fileName]) {
				return false;
			}

			// Simple implementation for direct check
			const fieldTypes = {};
			for (const header in this.fileSpecificMappings[fileName]) {
				const fieldType = this.fileSpecificMappings[fileName][header];

				if (fieldType !== 'ignore') {
					foundMaps.push(fieldType);
					this.suppliedHeaders[fieldType] = true;
					if (fieldTypes[fieldType]) {
						this.dupedSuppliedHeaders[fieldType] = true;
						return true; // Duplicate found
					}
					fieldTypes[fieldType] = true;
				}
			}
			return false;
		}

		// For "all files" view, check each file
		for (const file of this.availableFiles) {
			if (!this.fileSpecificMappings[file]) {
				continue;
			}

			const fieldTypes = {};

			for (const header in this.fileSpecificMappings[file]) {
				const fieldType = this.fileSpecificMappings[file][header];

				if (fieldType !== 'ignore') {
					foundMaps.push(fieldType);
					this.suppliedHeaders[fieldType] = true;

					if (fieldTypes[fieldType]) {
						this.dupedSuppliedHeaders[fieldType] = true;
						return true; // Duplicate found
					}
					fieldTypes[fieldType] = true;
				}
			}
		}


		return false;
	}

	applyColumnMappings() {
		const processedData = [];
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.uploadedRawData.forEach(row => {
			const processedRow: any = {
				_sourceFile: row._sourceFile
			};
			const fileName = row._sourceFile;

			if (fileName && this.fileSpecificMappings[fileName]) {
				Object.keys(row).forEach(originalHeader => {
					if (originalHeader === '_sourceFile') {return;}
					const mappedField = this.fileSpecificMappings[fileName][originalHeader];
					if (mappedField && mappedField !== 'ignore') {
						processedRow[mappedField] = row[originalHeader];
					}
				});
			} else {
				Object.keys(row).forEach(originalHeader => {
					if (originalHeader === '_sourceFile') {return;}

					const mappedField = this.columnMappings[originalHeader];
					if (mappedField && mappedField !== 'ignore') {
						processedRow[mappedField] = row[originalHeader];
					}
				});
			}
			if (processedRow['stockid'] || processedRow['qty_purchase']) {
				if (!processedRow['stockid']) {processedRow['stockid'] = '';}
				if (!processedRow['qty_purchase']) {processedRow['qty_purchase'] = 1;}
				if (!processedRow['price']) {processedRow['price'] = 0;}

				processedData.push(processedRow);
			}
		});
		return processedData;
	}

	uploadOrder(options?: { userInitiated?: boolean }): void {
		const userInitiated = options?.userInitiated === true;
		if (!this.files.length) {
			if (userInitiated) {
				this.globalSearchService.showNotification('Add at least one file first.', 'info', 'bottom', 'left');
			}
			return;
		}
		if (!this.debtorno) {
			this.globalSearchService.showNotification('Select a customer before uploading order files.', 'warning', 'bottom', 'left');
			return;
		}

		this.resetUploadOrder();
		this.uploaddata = {
			items: [],
			lines: { good: 0, bad: 0 }
		};

		this.upload_error = false;
		this.uploadedRawData = [];
		this.uploadedHeaders = [];
		this.fileSpecificHeaders = {};
		this.fileSpecificMappings = {};
		this.availableFiles = [];
		this.orderDataSource = false;
		this.processing_recs = true;
		this.orderUploadSelectedTabIndex = 0;

		let filesRemaining = this.files.length;
		const allFileData: any[] = [];

		const pushUploadError = (msg: string) => {
			if (!this.upload_error) {
				this.upload_error = [];
			}
			if (Array.isArray(this.upload_error)) {
				this.upload_error = [msg, ...this.upload_error];
			} else {
				this.upload_error = [msg, String(this.upload_error)];
			}
		};

		const finishOneFile = () => {
			filesRemaining--;
			if (filesRemaining > 0) {
				return;
			}

			this.uploadedRawData = allFileData;
			this.selectedFile = 'all';
			this.initializeColumnMappings();

			if (this.upload_error && Array.isArray(this.upload_error) && this.upload_error.length) {
				const msg = this.upload_error.join('; ');
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'left');
				this.resetUploadOrder();
				return;
			}

			if (allFileData.length === 0) {
				this.globalSearchService.showNotification(
					'No data rows found. Use the first sheet with a header row.',
					'warning',
					'bottom',
					'left'
				);
				this.resetUploadOrder();
				return;
			}

			this.orderReviewReady = true;
			this.processing_recs = false;
			this.orderUploadSelectedTabIndex = 0;
			this.syncMappingsFulfilledStatus();

			if (userInitiated) {
				this.globalSearchService.showNotification(
					'Map columns if needed, then Apply Mappings to validate SKUs against inventory.',
					'success',
					'bottom',
					'left'
				);
			}
		};

		const runLocal = () => {
			for (let i = 0; i < this.files.length; i++) {
				const file = this.files[i];
				const name = file.name;

				if (!this.availableFiles.includes(name)) {
					this.availableFiles.push(name);
				}

				this.parseOrderSpreadsheetLocal(file)
					.then(rows => {
						const dataWithFileSource = rows.map((row: Record<string, string>) => ({
							...row,
							_sourceFile: name
						}));
						allFileData.push(...dataWithFileSource);
						if (rows.length > 0) {
							const currentHeaders = Object.keys(rows[0]);
							this.fileSpecificHeaders[name] = [...currentHeaders];
							this.uploadedHeaders = [...new Set([...this.uploadedHeaders, ...currentHeaders])];
						}
						finishOneFile();
					})
					.catch(() => {
						pushUploadError(`Could not read spreadsheet: ${name}`);
						finishOneFile();
					});
			}
		};

		if (typeof requestAnimationFrame !== 'undefined') {
			requestAnimationFrame(() => runLocal());
		} else {
			setTimeout(() => runLocal(), 0);
		}
	}

	applyMappingsAndProcessOrder() {

		const processedData = this.applyColumnMappings();
		this.checkForDuplicateMappings();

		this.uploaddata = {
			items: [],
			lines: { good: 0, bad: 0 }
		};

		processedData.forEach(row => {
			if (parseFloat(row.qty_purchase) != 0) {
				this.uploaddata['items'].push({
					stockid: row.stockid,
					quantity: row.qty_purchase,
					price: row.price || 0,
					description: row.description || '',
					discount: 0,
					mapped: 1,
					brand: row.brand,
					_sourceFile: row._sourceFile || ''
				});
			}
		});

		const data = {
			items: this.uploaddata['items'],
			debtorno: this.debtorno,
			branchcode: this.branchcode,
			mfgparts: this.lookupType
		};

		this.mappingApplyProcessing = true;

		this.orderService.buildOrderFromUpload(data).subscribe({
			next: (res) => {
				this.orderDataSource = {};

				if (res['good']) {
					this.orderDataSource['good'] = new MatTableDataSource(res['good']);
					res['good'].forEach(() => {
						this.uploaddata['lines']['good']++;
					});
					this.uploaddata['items'] = res['good'];
				}

				if (res['bad']) {
					this.orderDataSource['bad'] = new MatTableDataSource(res['bad']);
					res['bad'].forEach(() => {
						this.uploaddata['lines']['bad']++;
					});
				}

				this.mappingApplyProcessing = false;
				this.syncMappingsFulfilledStatus();
				this.globalSearchService.showNotification(
					'Mapping applied — check Recognized and Unrecognized tabs.',
					'success',
					'bottom',
					'left'
				);
			},
			error: () => {
				this.mappingApplyProcessing = false;
				this.globalSearchService.showNotification(
					'Could not apply mappings. Try again or adjust column mapping.',
					'danger',
					'bottom',
					'left'
				);
			}
		});
	}

	addOrderItems() {

		if (this.uploaddata['items'] && this.uploaddata['items'].length > 0) {
			this.orderService.addBatchItemsToCart(this.uploaddata['items'], this.debtorno, this.branchcode, 'batch').subscribe((results: any) => {
				this.cart_items = results;
				this.resetUploadOrder();
				this.modalService.dismissAll();
				this.uploaded.emit();
				this.globalSearchService.showNotification(
					'Items added to cart — opening order / cart.',
					'success',
					'bottom',
					'left'
				);
			});
		}
	}

	hasNededMaps(){
		//avail
		this.availableFieldTypes
	}

	resetUploadOrder() {
		this.orderReviewReady = false;
		this.processing_recs = false;
		this.mappingApplyProcessing = false;
		this.orderDataSource = false;
		this.uploadedRawData = [];
		this.uploadedHeaders = [];
		this.columnMappings = {};
		this.fileSpecificHeaders = {};
		this.fileSpecificMappings = {};
		this.availableFiles = [];
		this.selectedFile = 'all';
	}

	toggleUploadHelp() {
		this.poHelp = this.poHelp == true ? false : true;
	}

	onSelect(event: NgxDropzoneChangeEvent) {
		if (!event) {
			return;
		}
		if (event.rejectedFiles?.length) {
			const names = event.rejectedFiles.map(f => f.name).join(', ');
			this.globalSearchService.showNotification(
				`Not added (type, size, or single-file limit): ${names}`,
				'warning',
				'bottom',
				'left'
			);
		}
		if (!event.addedFiles?.length) {
			return;
		}
		const valid: File[] = [];
		const invalidNames: string[] = [];
		for (const f of event.addedFiles) {
			const lower = f.name.toLowerCase();
			if (this.orderUploadAllowedExtensions.some(ext => lower.endsWith(ext))) {
				valid.push(f);
			} else {
				invalidNames.push(f.name);
			}
		}
		if (invalidNames.length) {
			this.globalSearchService.showNotification(
				`Only CSV and Excel are supported. Skipped: ${invalidNames.join(', ')}`,
				'warning',
				'bottom',
				'left'
			);
		}
		if (valid.length) {
			this.files.push(...valid);
			this.upload_error = false;
			queueMicrotask(() => {
				if (!this.debtorno || this.processing_recs || this.orderReviewReady) {
					return;
				}
				this.uploadOrder();
			});
		}
	}

	formatFileSizeKb(bytes: number): string {
		return (bytes / 1024).toFixed(1);
	}

	downloadOrderUploadTemplate(): void {
		const header = 'stockid,qty_purchase,price,description';
		const sample1 = 'ITEM-12345,4,78.92,Example line one';
		const sample2 = 'ITEM-67890,2,12.50,Example line two';
		const csv = [header, sample1, sample2].join('\n');
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		FileSaver.saveAs(blob, 'order_upload_template.csv');
	}

	onRemove(file: File) {
		const index = this.files.indexOf(file);
		if (index !== -1) {
			this.files.splice(index, 1);
		}
		this.upload_error = false;
	}

	handleOrderUpload(event: any) {
		if (event && event.success) {
			if (event.orderno) {
				this.globalSearchService.showNotification('Order successfully uploaded', 'success', 'bottom', 'left');
				this.router.navigate(['/orders/invoice/' + event.orderno]);
			} else {
				this.orderService.getCart(this.debtorno, this.branchcode).subscribe((items: any) => {
					this.cart_items = items;
					this.uploaded.emit();
					this.globalSearchService.showNotification(
						'Items added to cart — opening order / cart.',
						'success',
						'bottom',
						'left'
					);
				});
			}
		} else if (event && event.error) {
			this.globalSearchService.showNotification('Upload failed: ' + event.message, 'danger', 'bottom', 'left');
		}
	}


	changeLookup(){
		this.lookupType = !this.lookupType;
		if(this.lookupType){
			this.availableFieldTypes =  ['stockid', 'qty_purchase', 'price', 'brand', 'description', 'ignore'];
			this.requiredMappings = { 'stockid':false, 'qty_purchase':false, 'price':false, 'brand':false };
		}else{
			this.availableFieldTypes =  ['stockid', 'qty_purchase', 'price', 'description', 'ignore'];
			this.requiredMappings = { 'stockid':false, 'qty_purchase': false, 'price': false };
		}
		this.checkForDuplicateMappings();
	}


}
